import {
  faFile,
  faFileWord,
  faFilePdf,
  IconDefinition,
} from '@document-crunch/pro-regular-svg-icons'

const ICON_PER_EXTENSION: Record<string, IconDefinition> = {
  /* In case we don't have a meaningful file extension to can use this key as fallback. */
  default: faFile,
  /* Available file extensions. */
  doc: faFileWord,
  docx: faFileWord,
  pdf: faFilePdf,
}

export const getFileIconByExtension = (file: File) => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase() || 'default'
  const icon = ICON_PER_EXTENSION[fileExtension] || ICON_PER_EXTENSION.default

  return icon
}
